export { default } from './SettingsById';
